import React, { Component } from 'react';
import Table from '../../../../../components/_table/Table';
import Panel from '../../../../../components/outline/Panel';
import Button from '../../../../../components/Button';
import { REMOTE_SPLASH_IMAGE_CREATE_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { comparePrePropsAndNextProps, reDirectPage } from '../../../../../lib/common';
import { columns } from './columns';
import './RemoteImageSplashList.scss';

class RemoteImageSplashList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { remoteImageList, initialOption, pagination, getList } = this.props;

    return (
      <Panel className="remote-image-list">
        <div className="panel-header">
          <div className="title">스플래시 이미지 리스트</div>

          <Button
            isRadius
            color="primary"
            text="등록하기"
            onClick={() =>
              reDirectPage({
                path: REMOTE_SPLASH_IMAGE_CREATE_URL_PATH,
              })
            }
          />
        </div>

        <div className="panel-body">
          <Table
            columns={() => columns()}
            rowKey={(record) => record.id}
            initialOption={initialOption}
            pagination={pagination}
            list={remoteImageList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    );
  }
}

export default RemoteImageSplashList;
